export const partnerPanelPath = () => '/partners/panel';

export const partnerWizardPath = () => '/partners/panel/nuevo';

export const partnerBusinessPath = (businessId: string) => `/partners/panel/${businessId}`;

export const partnerEditProfilePath = (businessId: string) => `/partners/panel/${businessId}/editar`;
